import Head from 'next/head';
import React from 'react';

import { Container, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Footer from '../components/Footer';
import Nav from '../components/NewNav';

const useStyles = makeStyles((theme) => ({
  nav: {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: 'white',
    },
  },
  title: {
    color: '#000000',
    fontWeight: 'bold',
    fontSize: 40,
    lineHeight: '40px',
    textAlign: 'center',
    marginTop: 70,
    marginBottom: 40,
  },
}));

const Terms = () => {
  const classes = useStyles({});
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <>
      <Head>
        <title>Terms of Service - Breezy</title>
      </Head>
      <Nav className={classes.nav} />
      <Container>
        <h1 className={classes.title}>Terms of Service</h1>
        <p>
          These are the Terms of Business for Sobreezy.com which we urge you to
          read prior to using our website for the purposes of getting an
          insurance quotation. Please send an email to hi@sobreezy.com if there
          is anything you would like us to clarify for you.
        </p>
        <h2>Who are we?</h2>
        <p>
          Sobreezy.com is a website that aggregates pet insurance quotes from
          various pet insurance providers. Our goal is to help you quickly get
          the quotes and be able to compare them. We do not recommend any
          specific quote or pet insurance provider during this process.
        </p>

        <h2>What does Sobreezy.com do?</h2>
        <p>
          We take the details that you enter into our website and process it
          with our insurer partners. We display a range of insurance products to
          you, in order that you may choose the most suitable policy for your
          requirements. Once you decide which insurance policy to buy then you
          will either click to that insurer’s website in order to buy directly
          from them or call them over the telephone from a phone number that’s
          displayed on our website.
          <br />
          We do not charge anything to you for using our service.
          <br />
          We do not make any recommendations on which policy you should buy. Our
          service is limited to:
        </p>
        <p>
          - Collecting the necessary information in order to get the quotes.
          <br />
          - Displaying sufficient information to you in order that you can make
          an informed decision on which policy to purchase
          <br />
          - Introducing you to the insurer that you choose to buy a policy from
          <br />
        </p>
        <p>
          The insurer you choose to use will inform you of the basis on which
          you are buying your insurance policy.
        </p>

        <h2>Information you provide</h2>
        <p>
          It is your responsibility to provide the necessary information in
          order that you can be provided the most appropriate insurance
          quotations.
          <br /> If you do not provide truthful answers then, in the event of a
          claim, your insurer may refuse to pay.
          <br />
          If you are in any doubt about any of the answers you’ve provided
          during the quote process, then please discuss this with the insurer
          that you choose to buy a policy from.
          <br />
          If you choose to buy your policy online from one of our insurer
          partners then please check your details are correct on their website
          before you complete the payment process.
          <br />
          If you choose to buy your policy over the phone then please check your
          quotation details are correct with the agent handling your call.
        </p>

        <h2>Our liability to you</h2>
        <p>
          The software we use is very complex and sophisticated, and while we
          make every reasonable effort to ensure that our website is error and
          bug free, we do acknowledge that sometimes mistakes can occur.
          <br />
          When you get an insurance quotation from Sobreezy.com, we do not
          change any of the information you provide and we make every effort to
          submit your details accurately.
          <br />
          You are then responsible for selecting which insurer to buy your
          insurance policy through. We cannot guarantee the solvency or ability
          of any of our insurer partners though. Additionally, we cannot make
          any representations or provide any warranties to any product that you
          choose to buy, nor do we accept any liability in connection with any
          product.
          <br />
          In no event shall we be liable for direct, special, indirect,
          punitive, exemplary or consequential damages, including lost profits,
          revenues or savings, even if we have been advised of the possibility
          of such damages in advance. Because some jurisdictions do not allow
          the exclusion or limitation of liability for negligence,
          consequential, incidental or other damages, in such jurisdictions our
          liability is limited to the greatest extent permitted by applicable
          law. Your sole and exclusive remedy for dissatisfaction with this
          website, any service we provide or any content is to stop using the
          website.
        </p>

        <h2>Data protection</h2>
        <p>
          We take Data Protection very seriously and we want you to feel
          confident regarding the privacy and security of your data.
          <br />
          We follow very strict procedures regarding the storage and disclosure
          of your personal information.
          <br />
          We have to disclose your personal information to our insurer partners
          in order for them to provide you with accurate quotations.
          <br />
          The insurer that you choose to buy your policy with will have it’s own
          Data Protection policy, which may differ from ours. Our insurer
          partners are not entitled to contact you for any reason, with the
          exception of trying to arrange your pet insurance policy that you have
          provided your personal information for.
        </p>

        <h2>Complaints</h2>
        <p>
          If you have any issues regarding your insurance policy once purchased,
          for example your insurance documents are missing, then you should
          contact your insurer directly.
          <br />
          Sobreezy.com does not have a record of which insurer you have used. If
          you are unsure then the best way usually is to check your bank
          statement to see whom payment was made to.
          <br />
          For anything else, please always feel free to contact us by email –
          hi@Sobreezy.com and as part of our customer charter, we will always
          get back to you within 4 hours of receiving your email*
          <br />
          We pride ourselves on providing great service and will always do our
          best to help you.
          <br />
          *Our email support team is available 9am – 7pm Monday to Sunday. If
          your email is sent outside of those hours then we will get back to you
          the next day.
        </p>

        <h2>USA only</h2>
        <p>
          Sobreezy.com is designed to be used solely by USA residents seeking
          insurance within the USA.
        </p>

        <h2>Accessing our website</h2>
        <p>
          Access to Sobreezy.com is free and we reserve the right to withdraw or
          amend our service or content without notice at any time.
          <br />
          We have taken every reasonable effort to ensure that our content is
          accurate and up to date, however, we are unable to accept any
          liability for any errors or omissions.
        </p>

        <h2>Third party websites</h2>
        <p>
          Sobreezy.com may provide links to third party websites. We are unable
          to accept any liability for the information or content of any third
          party website. We cannot also guarantee that any third party website
          will be free from viruses or anything else that could be infectious or
          destructive.
        </p>
        <h2>Commercial use</h2>
        <p>
          Sobreezy.com is provided free of charge for individuals to obtain
          their own insurance quotations. The website may not be used for
          commercial use or price scraping.
        </p>

        <h2>Intellectual property</h2>
        <p>
          All Intellectual Property Rights and Copyright material in connection
          with Sobreezy.com are reserved and protected by law for our sole use.
          It is against the law to imitate any of our content or in any way
          interfere with our legal property.
        </p>
      </Container>
      <Footer />
      <style jsx global>
        {`
          body {
            background-color: #f7f7fa !important;
          }
        `}
      </style>
      <style jsx>
        {`
          p {
            font-size: 16px;
            line-height: 36px;
            margin-top: 0;
            margin-bottom: 40px;
          }
          h2 {
            font-size: 16px;
            line-height: 36px;
            margin: 0;
          }
        `}
      </style>
    </>
  );
};

export default Terms;
